const ACCOUNT_URL = import.meta.env.VITE_ACCOUNT_FRONTEND_URL || 'http://localhost:4003'

export function getAccountUrl(path: string) {
  return `${ACCOUNT_URL}${path}`
}

export function getAccountUrlWithRedirection(
  path: string,
  options?: {
    redirectionUrl?: string
    searchParams?: { key: string; value: string }[]
  }
) {
  const redirectUrl = options?.redirectionUrl ? buildCurrentAppUrl(options.redirectionUrl) : window.location.href
  const encodedRedirectUrl = encodeURIComponent(redirectUrl)
  let url = `${ACCOUNT_URL}${path}?videoconference_redirect_url=${encodedRedirectUrl}`
  options?.searchParams?.forEach(({ key, value }) => {
    url += `&${key}=${value}`
  })
  return url
}

export function redirectToAccountWithRedirection(
  path: string,
  options?: {
    redirectionUrl?: string
    searchParams?: { key: string; value: string }[]
  }
) {
  window.location.href = getAccountUrlWithRedirection(path, options)
}

export function isExternalUrl(url: string) {
  return url.startsWith('http')
}

function buildCurrentAppUrl(url: string) {
  const base = window.location.origin
  return isExternalUrl(url) ? url : `${base}${url}`
}
